<template>
  <div id="app" :class="{hide_header: $route.path === '/'}">
    <div class="header" v-if="$route.path !== '/'">
      <div class="logo_img" @click="logoClick">
        <div
          style="display: flex; align-items: center; float: left; height: 65px"
        >
          <div class="header-logo">
            <img id="header-img" src="../assets/logo.png" />
          </div>
        </div>
        <div style="display: flex; float: left; height: 65px">
          <div class="header-important">
            <div class="company_name">彩虹短剧</div>
            <div class="header-title company_name"></div>
          </div>
        </div>
      </div>
      <div id="menu_index">
        <!-- web端菜单导航 -->
        <el-menu
          v-if="seen"
          :default-active="activeIndex"
          class="el-menu-demo"
          menu-trigger="click"
          text-color="#333"
          style="height: 65px; border: 0"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1" class="header-title">{{ $t('nav.home') }}</el-menu-item>
          <el-menu-item index="2-1" class="header-title">{{ $t('nav.appIntro') }}</el-menu-item>
          <el-menu-item index="5" class="header-title">{{ $t('nav.aboutUs') }}</el-menu-item>
        </el-menu>
        <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
        <el-menu
          v-if="!seen"
          :default-active="activeIndex"
          class="el-menu-demo"
          menu-trigger="click"
          text-color="#333"
          style="height: 65px; border: 0"
          mode="horizontal"
          @select="handleSelectMobile"
        >
          <el-submenu index="1" class="header-title mobile_menu">
            <template slot="title">{{ currentMenu }}</template>
            <el-menu-item index="1" class="header-title">{{ $t('mobileNav.home') }}</el-menu-item>
            <el-menu-item index="2-2" class="header-title"
              >{{ $t('mobileNav.fruit') }}</el-menu-item
            >
            <el-menu-item index="2-1" class="header-title"
              >{{ $t('mobileNav.productMicro') }}</el-menu-item
            >
            <el-menu-item index="3" class="header-title">{{ $t('mobileNav.features') }}</el-menu-item>
            <el-menu-item index="4" class="header-title">{{ $t('mobileNav.partners') }}</el-menu-item>
            <el-menu-item index="5" class="header-title">{{ $t('mobileNav.aboutUs') }}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <el-button v-if="$route.path !== '/'" class="lang-switch-btn-top" size="small" @click.stop="toggleLang">
      {{ $t('nav.home') === '首页' ? 'English' : '中文' }}
    </el-button>
    <div class="container" style="clear: both">
      <router-view></router-view>
    </div>

    <template v-if="$route.path !== '/'">
    <div style="width: 90%; margin: 20px auto">
      <div style="height: 1px; padding: 0; background-color: #999"></div>
    </div>
    <div style="width: 90%; margin: 20px auto">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12">
          <div class="footer_font">{{ $t('footer.contact') }}</div>
          <div style="margin: auto;" class="footer_font">
            {{ $t('footer.company') }}
          </div>
          <div style="margin: auto" class="footer_font"></div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div>
            <img
              :src="company.qrcode"
              style="width: 100px; height: 100px; border: 0"
            />
          </div>
          <div class="footer_font" style="width: 100px; text-align: center">
            {{ $t('footer.appDownload') }}
          </div>
        </el-col>
      </el-row>
    </div>
    </template>
    <div id="back_to_top" ref="btn" @click="backTop" style="display: none">
      <p style="font-size: 0.625em; font-weight: bold">{{ $t('top') }}</p>
      <img src="../assets/other/launch.png" style="height: 45px; width: 35px" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      activeIndex: "1",
      company: {
        qrcode: require("@/assets/icon/qrcode.png"),
      },
      scroll: "",
      timer: "",
      seen: true,
      currentMenu: "首页",
    };
  },
  watch: {
    $route() {
      this.updateCurrentMenu();
    },
  },
  methods: {
    toggleLang() {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
    },
    updateCurrentMenu() {
      const navMap = {
        '1': 'nav.home',
      };
      if (this.activeIndex === '1') {
        this.currentMenu = this.$t('nav.home');
      }
    },
    handleSelect(key) {
      switch (key) {
        case "1":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" });
          }
          break;
        case "2-1":
          this.$router.push({ name: "AppIntro" });
          break;
        case "2-2":
          this.$router.push({ name: "Fruit" });
          break;
        case "2-3":
          window.location.hash = "#案例展示";
          break;
        case "3":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" }).then(() => {
              window.location.hash = "#服务流程";
            });
          } else {
            window.location.hash = "#服务流程";
          }
          break;
        case "4":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" }).then(() => {
              window.location.hash = "#合作伙伴";
            });
          } else {
            window.location.hash = "#合作伙伴";
          }
          break;
        case "5":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" }).then(() => {
              window.location.hash = "#about-us";
            });
          } else {
            window.location.hash = "#about-us";
          }
          break;
      }
    },
    handleSelectMobile(key) {
      switch (key) {
        case "1":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" });
          }
          this.currentMenu = this.$t('mobileNav.home');
          break;
        case "2-1":
          this.$router.push({ name: "AppIntro" });
          this.currentMenu = this.$t('mobileNav.productMicro');
          break;
        case "2-2":
          this.$router.push({ name: "Fruit" });
          this.currentMenu = this.$t('mobileNav.fruit');
          break;
        case "2-3":
          this.$router.push({ name: "Fashion" });
          break;
        case "3":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" }).then(() => {
              window.location.hash = "#服务流程";
            });
          } else {
            window.location.hash = "#服务流程";
          }
          this.currentMenu = this.$t('mobileNav.features');
          break;
        case "4":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" }).then(() => {
              window.location.hash = "#合作伙伴";
            });
          } else {
            window.location.hash = "#合作伙伴";
          }
          this.currentMenu = this.$t('mobileNav.partners');
          break;
        case "5":
          if (this.$route.name !== "home") {
            this.$router.push({ name: "home" }).then(() => {
              window.location.hash = "#about-us";
            });
          } else {
            window.location.hash = "#about-us";
          }
          this.currentMenu = this.$t('mobileNav.aboutUs');
          break;
      }
    },
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 600) {
        //判断滚动后高度超过400px,就显示
        this.$refs.btn.style.display = "block";
      } else {
        this.$refs.btn.style.display = "none";
      }
    },
    backTop() {
      //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
      this.timer = setInterval(() => {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(this.timer);
        }
      }, 30);
    },
    login() {
      window.open("https://admin.fastice-tech.com/login");
    },
    register() {
      window.open("https://admin.fastice-tech.com/registe");
    },
    menuSeen() {
      // 屏幕尺寸
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        this.seen = true;
      } else {
        this.seen = false;
      }
    },
    logoClick() {
      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" });
      }
      this.currentMenu = this.$t('nav.home');
    },
  },
  mounted() {
    this.menuSeen();
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.logo_img {
  float: left;
  width: 30%;
  cursor: pointer;
}

#back_to_top {
  position: fixed;
  bottom: 50px;
  right: 30px;
  cursor: pointer;
}

.header-title {
  font-size: 1em;
}

.company_name {
  font-weight: normal;
  font-size: 1em;
}

.lang-switch-btn {
  margin-left: 10px;
  border-color: #dcdfe6;
  color: #606266;
}

.lang-switch-btn:hover {
  color: #409eff;
  border-color: #409eff;
}

.lang-switch-btn-top {
  position: fixed;
  top: 12px;
  right: 30px;
  z-index: 999;
  border-color: #409eff;
  color: #409eff;
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.lang-switch-btn-top:hover {
  color: #fff;
  background: #409eff;
  border-color: #409eff;
}

.footer_font {
  font-size: 1em;
}

#menu_index {
  float: right;
  width: 40%;
  height: 100%;
}

.header {
  margin: auto;
  width: 90%;
  height: 65px;
  /*background: #F56C6C;*/
}

@media screen and (max-device-width: 415px) {
  .logo_img {
    float: left;
    width: auto;
    cursor: pointer;
  }

  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 5px;
    cursor: pointer;
  }

  .footer_font {
    font-size: 0.875em;
  }

  #menu_index {
    float: right;
    width: auto;
    height: 100%;
  }

  .mobile_menu {
  }
}

#header-img {
  width: 50px;
  height: 50px;
  border-radius: 20px;
  float: left;
  margin: auto;
}

.header-logo {
  height: 50px;
  width: 50px;
  align-self: center;
}

.header-important {
  float: left;
  margin-left: 6px;
  align-self: center;
}

.footer {
  display: flex;
  align-items: center;
  margin: 10px auto;
  width: 90%;
}

a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
</style>
